var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 32,
    height: 32,
    rx: 10,
    fill: "#100F15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14C11 13.448 11.448 13 12 13C12.552 13 13 13.448 13 14C13 14.552 12.552 15 12 15C11.448 15 11 14.552 11 14ZM16 13C15.448 13 15 13.448 15 14C15 14.552 15.448 15 16 15C16.552 15 17 14.552 17 14C17 13.448 16.552 13 16 13ZM20 13C19.448 13 19 13.448 19 14C19 14.552 19.448 15 20 15C20.552 15 21 14.552 21 14C21 13.448 20.552 13 20 13ZM24 19C24 19.551 23.551 20 23 20H12.554C12.011 20 11.477 20.148 11.01 20.428L8 22.234V9C8 8.449 8.449 8 9 8H23C23.551 8 24 8.449 24 9V19ZM23 6H9C7.346 6 6 7.346 6 9V24C6 24.36 6.194 24.693 6.507 24.87C6.66 24.957 6.83 25 7 25C7.178 25 7.356 24.953 7.515 24.857L12.039 22.143C12.195 22.049 12.373 22 12.554 22H23C24.654 22 26 20.654 26 19V9C26 7.346 24.654 6 23 6Z",
    fill: "#100F15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.f3df396306b14cd8256bb81d9701ae80.svg";
export { ForwardRef as ReactComponent };